<ng-container *ngIf="showLoader">
    <div class="loading-overlay">
        <div class="loading-container">
            <ng-container *ngIf="type === 'Default'">
                <ng-lottie class="animation" [options]="defaultOptions"></ng-lottie>
            </ng-container>

            <ng-container *ngIf="type === 'Documents'">
                <div class="subtitle" tracking formname="Smart invest line simulation" stepname="documents loader web"
                    [innerHTML]="'Loading.Documents' | translate | punctuationWrap">
                </div>
                <ng-lottie class="animation bg-white" [options]="documentsOptions"></ng-lottie>
            </ng-container>
        </div>
    </div>
</ng-container>